import { render, staticRenderFns } from "./WorkFlowFloatingTaskBarToggle.vue?vue&type=template&id=8f7f9750&scoped=true"
import script from "./WorkFlowFloatingTaskBarToggle.vue?vue&type=script&lang=js"
export * from "./WorkFlowFloatingTaskBarToggle.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowFloatingTaskBarToggle.vue?vue&type=style&index=0&id=8f7f9750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7f9750",
  null
  
)

export default component.exports